import React, { useState, useEffect } from 'react';

import { ContinueButton, AutocompleteInputWithConfirm, RadioOptionsWithConfirm, IQuestion } from 'shared-components';

import { Q } from '../../../../store/student/types';
import { IOtherNationality } from '../../../../types';

interface IProps {
  index: number;
  nationality: string;
  isCurrent?: boolean;
  suggestions: string[];
  onSaveAndClose: (otherNationality: IOtherNationality) => void;
}

const OtherNationality = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [nationality, setNationality] = useState(props.nationality);
  const [isCurrent, setIsCurrent] = useState(props.isCurrent);
  const [complete, setComplete] = useState(nationality !== '' && isCurrent !== undefined);

  const [suggestions, setSuggestions] = useState(props.suggestions);

  const saveAndClose = () => {
    onSaveAndClose({
      nationality,
      isCurrent
    });
  };

  const handleOnSaveAndCloseClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    saveAndClose();
  };

  useEffect(() => {
    setComplete(nationality !== '' && isCurrent !== undefined);
  }, [nationality, isCurrent]);

  return (
    <>
      <AutocompleteInputWithConfirm
        key={`${Q.OTHER_NATIONALITIES}-${index}`}
        id={`${Q.OTHER_NATIONALITIES}-${index}`}
        suggestions={suggestions}
        onBlur={(evt: any) => {
          const value = evt.currentTarget.value || '';
          if (suggestions.includes(value)) {
            setNationality(value);
          } else {
            setNationality('');
          }
          setSuggestions(props.suggestions);
        }}
        value={nationality}
        label={'Nationality:'}
        onChange={(evt: any): void => {
          const value = evt.currentTarget.value || '';
          const newSuggestions = [...props.suggestions].filter(s => s.toLowerCase().includes(value.toLowerCase()));
          setSuggestions(newSuggestions ? newSuggestions : []);
          setNationality(value);
        }}
      />

      <RadioOptionsWithConfirm
        key={`${Q.OTHER_NATIONALITIES_IS_CURRENT}-${index}`}
        id={`${Q.OTHER_NATIONALITIES_IS_CURRENT}-${index}`}
        value={isCurrent}
        label={'Is this a current or former nationality?'}
        onClick={(question: IQuestion): void => {
          setIsCurrent(question.label === 'Current');
        }}
        isInline={true}
        questions={[
          {
            char: '1',
            label: 'Current',
            selected: isCurrent === true
          },
          {
            char: '2',
            label: 'Former',
            selected: isCurrent === false
          }
        ]}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default OtherNationality;
